/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { Count } from '@core/lib/components/to-do-count/count';
import { OrderedMap } from '@core/lib/data-structures/ordered-map';

export class List {
  id: string;
  count: Count;
  children: OrderedMap;

  constructor(id: string) {
    this.id = id;
    this.children = new OrderedMap('id');
    this.count = new Count(0, 0, 0);
  }
}
